import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, Link } from '@mui/material';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx, ...other }, ref) => {
  const theme = useTheme();

  const PRIMARY_LIGHT = theme.palette.primary.light;

  const PRIMARY_MAIN = theme.palette.primary.main;

  const PRIMARY_DARK = theme.palette.primary.dark;


  const logoSrc = `${process.env.PUBLIC_URL || ''}/assets/logo.png`;

  const logo = (
    <Box
      component="img"
      // src="https://coolpressing.be/wp-content/uploads/2024/06/logo_cool_pressing.png"
      // src="https://www.coolpressing.be/web/image/website/1/logo/Cool%20Pressing?unique=e440b8e"
      src={logoSrc}
      justifyContent='center'
      sx={{ width: 150, height: 130, cursor: 'pointer', ...sx }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to="/" component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
